// extracted by mini-css-extract-plugin
export default {"icon-label":"icon-label-0a5d","icon-container":"icon-container-6651","label":"label-53e3"};